import {h} from 'preact'


export const RadioButtons = (props) => {
    const { optionOn, ariaLabelType } = props; 
    
    const getRadioOn = () => {
        const labelId = `${ariaLabelType} On;`
        const uniqueId = `radio-button-${ariaLabelType}-on`
        return (
            <div className="radio-buttons-list-item">
                <input 
                    name={ariaLabelType} 
                    value="On" 
                    type='radio' 
                    onClick={props.toggleOn} 
                    checked={optionOn ? true : false}
                    id={uniqueId} 
                />
                <label id={labelId} className="option-label" for={uniqueId}>On</label>
            </div>
        )
    }

    const getRadioOff = () => {
        const labelId = `${ariaLabelType} Off`
        const uniqueId = `radio-button-${ariaLabelType}-off`
        return (
            <div className="radio-buttons-list-item">
                <input  
                    id={uniqueId} 
                    name={ariaLabelType} 
                    value="Off" 
                    type='radio' 
                    onClick={props.toggleOff} 
                    checked={optionOn ? false : true} 
                />
                <label className="option-label" id={labelId} for={uniqueId}>Off</label>
            </div>
        )
    }



    return (
        <div ref={props.menuButtonRef} class="menu-radio-controls">
            {getRadioOn()}
            {getRadioOff()}
        </div>
    ) 
}

